import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import { TAffiliatedPagination, TAffiliatedStatus } from "../types/Affiliated";
import AffiliationController from "../controllers/AffiliationController";

export interface IAffiliatedProp {
    page: number;
    rows: number;
    search?: string;
    status?: TAffiliatedStatus;
}

const valueDefault = {
    items: [],
    page: 0,
    rowsPerPage: 0,
    totalPages: 0,
    total: 0,
};

export const useMyAffiliations = ({ page, rows, search, status }: IAffiliatedProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TAffiliatedPagination>(valueDefault);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await AffiliationController.getProducts({ page, rows, search, status });
                const responseError = response as IErrorResponse;
                const responseData = response as TAffiliatedPagination;

                if (responseError.code) {
                    setError(responseError.error);
                    setData(valueDefault);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, [page, rows, search, status]);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}